import { RiNotification3Line, RiTimeLine } from "react-icons/ri";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";

const CreationStartedModal = ({ isOpen, onClose, t }) => (
  <Modal centered isOpen={isOpen} size="md" toggle={onClose}>
    <ModalBody className="software-creation-started">
      <RiTimeLine className="text-primary" size="34" />
      <h3>{t("Software Creation Started")}</h3>
      <p>
        {t(
          "Your request has been accepted and the software creation process has started in the background."
        )}
      </p>
      <div className="software-creation-started__notice">
        <RiNotification3Line className="text-primary" size="24" />
        <span>
          {t(
            "You'll receive a notification when the process has completed or if any issues occur. You can safely continue using the application."
          )}
        </span>
      </div>
    </ModalBody>
    <ModalFooter className="justify-content-center border-0 pt-0 pb-4">
      <Button color="primary" className="px-4" onClick={onClose}>
        {t("Continue")}
      </Button>
    </ModalFooter>
  </Modal>
);

export default CreationStartedModal;

